export enum tagTypes {
  STATUS = "Status",
  WAREHOUSE_PLAN = "WarehousePlan",
  LOCATION = "Location",
  DETAIL = "Detail",
  NOTIFICATION = "Notification",
}
